import React from 'react'
import {render} from 'react-dom'
import {applyMiddleware, compose, createStore} from 'redux'
import createSagaMiddleware from 'redux-saga'
import flightsSaga from './saga/filterSaga'
import appliedFiltersSaga from './saga/appliedFiltersSaga'
import {Provider} from 'react-redux'
import FilterContainer from './components/FilterContainer'
import reducers from './reducers'
import FlightsContainer from "./components/FlightsContainer"
import UtilityHeaderContainer from "./components/UtilityHeaderContainer";
import PricesCalendarContainer from "./components/PricesCalendarContainer";
import IdleComponent from "./components/idle/IdleComponent";
import ReduxPromise from 'redux-promise';
import SocketContainer from "./components/SocketContainer";
import SearchComponentCotnainer from "./components/mobile/SearchComponentCotnainer";
import PreloaderContainer from "./components/PreloaderContainer";
import MiniLoaderContainer from "./components/MiniLoaderContainer";
import FareAlertContainer from "./components/FareAlertContainer";
import flightAlertSaga from "./saga/flightAlertSaga";
import ExpiredPriceNoticeContainer from "./components/ExpiredPriceNoticeContainer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(sagaMiddleware, ReduxPromise))
);

sagaMiddleware.run(flightsSaga);
sagaMiddleware.run(appliedFiltersSaga);
sagaMiddleware.run(flightAlertSaga);

//Base container for parameter and socket handling
const socketRoot = document.getElementById('flights-socket');
render(
    <Provider store={store}>
        <SocketContainer {...(socketRoot.dataset)}/>
    </Provider>,
    socketRoot
);

const idleRoot = document.getElementById('idle-container');
render(
    <Provider store={store}>
        <IdleComponent {...(idleRoot.dataset)}/>
    </Provider>,
    socketRoot
);

const utilityHeaderRoot = document.getElementById('utility-header-container');
render(
    <Provider store={store}>
        <div>
            <UtilityHeaderContainer {...(utilityHeaderRoot.dataset)}/>
        </div>
    </Provider>,
    utilityHeaderRoot
);

const pricesCalendarRoot = document.getElementById('flights-prices-calendar-container');
render(
    <Provider store={store}>
        <div>
            <PricesCalendarContainer {...(pricesCalendarRoot.dataset)}/>
        </div>
    </Provider>,
    pricesCalendarRoot
);

const expiredPriceNoticeRoot = document.getElementById('expired-price-notice-container');
if (expiredPriceNoticeRoot) {
    render(
        <Provider store={store}>
            <div>
                <ExpiredPriceNoticeContainer {...(expiredPriceNoticeRoot.dataset)}/>
            </div>
        </Provider>,
        expiredPriceNoticeRoot
    );
}

const filterRoot = document.getElementById('filters-container');
render(
    <Provider store={store}>
        <FilterContainer {...(filterRoot.dataset)}/>
    </Provider>,
    filterRoot
);

const resultsRoot = document.getElementById('flights-container');
render(
    <Provider store={store}>
        <FlightsContainer {...(resultsRoot.dataset)}/>
    </Provider>,
    resultsRoot
);

const mobileSearchRoot = document.getElementById('mobile-search-component');
render(
    <Provider store={store}>
        <div>
            <SearchComponentCotnainer {...(mobileSearchRoot.dataset)}/>
        </div>
    </Provider>,
    mobileSearchRoot
);

const preloaderRoot = document.getElementById('preloader-component-container');
render(
    <Provider store={store}>
        <div>
            <PreloaderContainer {...(preloaderRoot.dataset)}/>
        </div>
    </Provider>,
    preloaderRoot
);

const miniLoaderRoot = document.getElementById('mini-loader-component');
render(
    <Provider store={store}>
        <div>
            <MiniLoaderContainer {...(miniLoaderRoot.dataset)}/>
        </div>
    </Provider>,
    miniLoaderRoot
);

const fareAlertRoot = document.getElementById('fare-alert-component');
render(
    <Provider store={store}>
        <div>
            <FareAlertContainer {...(fareAlertRoot.dataset)}/>
        </div>
    </Provider>,
    fareAlertRoot
);



// WEBPACK FOOTER //
// ./src/index.js